const swap = {
	'swap.tips.no.wallet': 'Lütfen önce cüzdanınızı bağlayın',
	'swap.tips.no.number': 'Lütfen miktarı giriniz',
	'swap.tips.no.address': 'Alıcı adresinizi girin',
	'swap.tips.address.error': 'Adres hatası',
	'swap.tips.error': 'Değişim başarısız oldu',
	'swap.tips.max': 'Maksimum miktar: {{msg}}',
	'swap.tips.min': 'Minimum miktar: {{msg}}',

	'swap.card.send': 'Gönder',
	'swap.card.receive': 'Al',
	'swap.card.tips': 'Para birimini veya biletleri girin',
	'swap.card.min': 'min:',
	'swap.card.max': 'max:',

	'swap.btn.title': 'Hedef',
	'swap.input.tips': 'Ödeme adresi',
	'swap.title.order': 'Sipariş Türü',

	'swap.tab.1': 'Sabit döviz kuru (%1,0)',
	'swap.tab.2': 'Dalgalı döviz kuru (%0,5)',

	'swap.btn.tipss': 'Fark nedir? ',
	'swap.btn.swap': 'Takas işlemini başlat',

	'swap.tips.1': `Bu web sitesini kullanarak ve bir geri ödeme oluşturarak, Fast Coin Mixer'ın`,
	'swap.tips.2': 'Hizmet Şartları',
	'swap.tips.3': 've',
	'swap.tips.4': 'Gizlilik Politikası',
	'swap.ipuçları.5': '. ',

	'swap.diff.title': 'Sabit ve dalgalı döviz kurları arasındaki fark nedir? ',

	'swap.paste.title': 'Yapıştır',
	'swap.help.title': 'SSS',
	'takas.yardım.1':
		'Üç şekilde: E-posta yoluyla (e-posta adresinizi bırakırsanız), web sitemiz üzerinden (tarayıcınız önbelleğe almayı kabul ediyorsa) veya blok zincirindeki kullanımınızı görüntülemek için sipariş bağlantınız aracılığıyla. ',
	'swap.help.2': `Kayıt gerekmez, kişisel bilgilerinizi paylaşmanıza gerek yok. Paranızı tutmuyoruz ve tüm çekimler anında ve tamamen otomatik modda gerçekleştirilir. `,
	'swap.help.3':
		'Dürüstlük bizim en büyük önceliğimizdir, bu nedenle tam şeffaflık sözü veriyoruz ve tüm ücretleri açıkça belirtiyoruz:',
	'swap.help.4': '• Sabit döviz kuru seçerseniz, %1 olacaktır',
	'swap.help.5': '• Eğer dalgalı faiz oranını seçerseniz, %0,5 olacaktır',
	'swap.help.6': 'SSS sayfasına girin',
	'swap.help.title1': 'Siparişlerimi nasıl takip edebilirim? ',
	'swap.help.title2': 'Size neden güvenebilirim? ',
	'swap.help.title3': 'Gizli ücretleriniz var mı? ',

	'swap.tips.title': `Güvenilir`,
	'swap.tips.card.title1': 'Zaman kazanın',
	'swap.tips.card.title2': 'Geri ödeme yap',
	'swap.tips.card.title3': 'Paradan tasarruf edin',
	'swap.tips.card.content1': 'Tüm süreç otomatik olduğundan, değişim hızı en hızlıdır',
	'swap.tips.card.content2': 'Kârlı bir değişim yapmak için doğru stratejiyi seçin',
	'swap.tips.card.content3': 'En iyi döviz kuru ve en düşük komisyon',

	'swap.trade.title': 'Son İşlemler',
}

export default swap
